<template>
  <div id="chair-selection-form">
    <dtk-estadio
      v-if="plano.nivel_cadeira !== null"
      :id_clube="clube.id.toString()" 
      :nivel="plano.nivel_cadeira" 
      :tem_setor="enableSetor" 
      :dependentes="dependentes" 
      v-model="user.cadeira_numero"
    />
    <dtk-estadio
      v-else
      :id_clube="clube.id.toString()" 
      :tem_setor="enableSetor" 
      :dependentes="dependentes" 
      v-model="user.cadeira_numero"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    dependentes: {
      required: true,
      type: Array
    },
    clube: {
      required: true,
      type: Object
    },
  },
  computed: {
    enableSetor() {
      return this.clube.id == 59 || this.clube.id == 94
    }
  },
  methods: {
    async submit() {
      try {
        return await this.$validator.validateAll()
      } catch (error) {
        return false
      }
    }
  }
})
</script>